<template>
	<div v-if="isShow" id="popup">
		<div class="black_bg"></div>
		<div class="twc-popup">
			<div class="popup-header">
				<p>상담하기</p>
				<img src="@/assets/img/close-x.svg" alt="닫기" @click="closeTwcPopup" />
			</div>

			<div class="popup_content">
				<p>
					안녕하세요.<br />
					신속하고 정확한 상담을 위해 정보를 먼저 입력해주세요.
				</p>
				<div class="divider"></div>
				<Form :validation-schema="schema" v-slot="{ meta }">
					<InputText
						label="이름"
						name="name"
						placeholder="이름을 입력하세요(실명)"
						v-model:value.trim="name"
					/>
					<InputText
						label="전화번호"
						name="phone"
						placeholder="전화번호를 입력하세요"
						v-model:value.trim="phone"
					/>
					<div class="divider"></div>
					<div class="popup-footer">
						<button
							class="confirm-button"
							type="button"
							:disabled="!meta.valid"
							@click.stop="moveToTwc"
						>
							확인
						</button>
					</div>
				</Form>
			</div>
		</div>
	</div>
</template>

<script>
import { ref } from 'vue';
import { Form } from 'vee-validate';
import InputText from '@/components/Input/InputText.vue';
import router from '@/router';

export default {
	name: 'TwcPopup',
	components: { InputText, Form },
	setup() {
		const schema = {
			name: 'required',
			phone: 'required|phone',
		};
		const name = ref('');
		const phone = ref('');

		const isShow = ref(false);
		const openTwcPopup = () => {
			isShow.value = true;
		};

		const closeTwcPopup = () => {
			isShow.value = false;
		};

		const moveToTwc = () => {
			closeTwcPopup();
			router.push({
				name: 'Twc',
				params: { name: name.value, phone: phone.value },
			});
		};

		return {
			isShow,
			schema,
			name,
			phone,
			openTwcPopup,
			closeTwcPopup,
			moveToTwc,
		};
	},
};
</script>

<style lang="scss" scoped>
.twc-containter {
	width: 100%;
	height: 100%;
	position: absolute;
}
#popup {
	width: 100%;
	height: 100%;
	position: absolute;
	z-index: 100;
	.black_bg {
		background: rgba($black100, 0.8);
		width: 100%;
		height: 100%;
	}
	.twc-popup {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: calc(100% - 32px);
		max-width: 351px;
		border-radius: 8px;
		background: #fff;
		.popup-header {
			padding: 16px;
			border-bottom: 1px solid $border;
			p {
				font-size: 18px;
				font-weight: bold;
				line-height: 1;
			}
			img {
				position: absolute;
				top: 16px;
				right: 16px;
				cursor: pointer;
			}
		}
		.popup_content {
			padding: 20px 16px;
			p {
				font-size: 14px;
				line-height: 1.2;
				color: $black60;
			}
		}
		.popup-footer {
			margin-top: 20px;
			width: 100%;
			button {
				width: 100%;
				height: 48px;
				font-size: 14px;
				font-weight: bold;
				background: var(--btn-active-bg);
				color: #fff;
				&:disabled {
					background: $disable;
					color: $black40;
				}
			}
		}
	}
}
.divider {
	width: 100%;
	height: 1px;
	margin-top: 20px;
	background: $border;
}
</style>
